// employeeTdsContributionSlice.ts

import { createSlice } from "@reduxjs/toolkit";
import {EmployeeTdsContributionState} from "./employeeTdsContributionTypes";
import {createEmployeeTdsContribution,fetchEmployeeTdsContributions,fetchEmployeeTdsContributionById,updateEmployeeTdsContribution,deleteEmployeeTdsContribution} from "./employeeTdsContributionAction";

const initialState: EmployeeTdsContributionState = {
  items: [],
  loading: false,
  error: null,
};

const employeeTdsContributionSlice = createSlice({
  name: "employeeTdsContribution",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Create
      .addCase(createEmployeeTdsContribution.pending, (state) => {
        state.loading = true;
      })
      .addCase(createEmployeeTdsContribution.fulfilled, (state, action) => {
        state.loading = false;
        state.items.push(action.payload);
      })
      .addCase(createEmployeeTdsContribution.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // Fetch All
      .addCase(fetchEmployeeTdsContributions.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchEmployeeTdsContributions.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload.data;
      })
      .addCase(fetchEmployeeTdsContributions.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // Fetch By ID
      .addCase(fetchEmployeeTdsContributionById.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchEmployeeTdsContributionById.fulfilled, (state, action) => {
        state.loading = false;
        const record = action.payload;
        const index = state.items.findIndex((i) => i.EmployeeTaxMapID === record.EmployeeTaxMapID);
        if (index >= 0) state.items[index] = record;
        else state.items.push(record);
      })
      .addCase(fetchEmployeeTdsContributionById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // Update
      .addCase(updateEmployeeTdsContribution.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateEmployeeTdsContribution.fulfilled, (state, action) => {
        state.loading = false;
        const updated = action.payload;
        const index = state.items.findIndex((i) => i.EmployeeTaxMapID === updated.id);
        if (index >= 0) state.items[index] = { ...state.items[index], ...updated };
      })
      .addCase(updateEmployeeTdsContribution.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // Delete
      .addCase(deleteEmployeeTdsContribution.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteEmployeeTdsContribution.fulfilled, (state, action) => {
        state.loading = false;
        state.items = state.items.filter((i) => i.EmployeeTaxMapID !== action.payload);
      })
      .addCase(deleteEmployeeTdsContribution.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export default employeeTdsContributionSlice.reducer;
